"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogoutComponentState = /** @class */ (function () {
    function LogoutComponentState() {
    }
    return LogoutComponentState;
}());
exports.default = LogoutComponentState;
//# sourceMappingURL=LogoutComponentState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/LogoutComponent/LogoutComponentState.js
// module id = 1696
// module chunks = 8